export const IS_LOADING_NEXT = 'PAGETEMPLATE/IS_LOADING_NEXT';
